module.exports = __webpack_public_path__ + "img/product-shot_01.159d024f.jpg";